export default [
  { name: 'Arabic', value: 'Arabic', label: 'Arabic' },
  { name: 'Armenian', value: 'Armenian', label: 'Armenian' },
  { name: 'Bengali', value: 'Bengali', label: 'Bengali' },
  {
    name: 'Chinese-Cantonese',
    value: 'Chinese-Cantonese',
    label: 'Chinese (Cantonese)',
  },
  {
    name: 'Chinese-Mandarin',
    value: 'Chinese-Mandarin',
    label: 'Chinese (Mandarin)',
  },
  {
    name: 'Creole-Haitian',
    value: 'Creole-Haitian',
    label: 'Creole (Haitian)',
  },
  { name: 'English', value: 'English', label: 'English' },
  { name: 'Farsi', value: 'Farsi', label: 'Farsi' },
  { name: 'French', value: 'French', label: 'French' },
  { name: 'German', value: 'German', label: 'German' },
  { name: 'Greek', value: 'Greek', label: 'Greek' },
  { name: 'Gujarati', value: 'Gujarati', label: 'Gujarati' },
  { name: 'Hebrew', value: 'Hebrew', label: 'Hebrew' },
  { name: 'Hindi', value: 'Hindi', label: 'Hindi' },
  { name: 'Italian', value: 'Italian', label: 'Italian' },
  { name: 'Japanese', value: 'Japanese', label: 'Japanese' },
  { name: 'Korean', value: 'Korean', label: 'Korean' },
  { name: 'Polish', value: 'Polish', label: 'Polish' },
  { name: 'Portuguese', value: 'Portuguese', label: 'Portuguese' },
  { name: 'Punjabi', value: 'Punjabi', label: 'Punjabi' },
  { name: 'Romanian', value: 'Romanian', label: 'Romanian' },
  { name: 'Russian', value: 'Russian', label: 'Russian' },
  { name: 'Spanish', value: 'Spanish', label: 'Spanish' },
  { name: 'Tagalog', value: 'Tagalog', label: 'Tagalog' },
  { name: 'Tamil', value: 'Tamil', label: 'Tamil' },
  { name: 'Telugu', value: 'Telugu', label: 'Telugu' },
  { name: 'Ukrainian', value: 'Ukrainian', label: 'Ukrainian' },
  { name: 'Urdu', value: 'Urdu', label: 'Urdu' },
  { name: 'Vietnamese', value: 'Vietnamese', label: 'Vietnamese' },
]
